import { ENocMLookUp, ENocMLookupData, EnocMollakDocuments, eNocUploadDoc, Mode, OwnerType } from "../../enocapi/entities";
import React, { Component } from "react";
import { populateENocMLookup } from "../../enocapi/services";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { getTabuDocName, getTabuDocType, TabuDocTypes } from "@my-dld/utils/TabuUtils";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import _ from "lodash";

interface Prop {
	documents: EnocMollakDocuments[];
	ownershipType: ENocMLookupData;
	isUAEResident: boolean;
	docsError?: any;
	mode?: Mode;
}

interface ENOCLookupState {
	CompanyDocuments: ENocMLookupData[];
	IndividualDocuments: ENocMLookupData[];
}

interface State extends ENOCLookupState {
	errorMsg?: string;
	error: any;
	documents: any[];
	docsError?: any;
}

export default class DocEnocM extends Component<Prop, State> {
	constructor( props: Prop ) {
		super( props );
		this.state = {
			...props,
			error: {},
			CompanyDocuments: [],
			IndividualDocuments: [],
			documents: this.props.documents && this.props.documents.length > 0 ? this.props.documents : [],
			docsError: props.docsError,
		};
	}

	componentDidMount(): void {
		populateENocMLookup( ENocMLookUp.COMPANY_DOCUMENTS, this, ( data ) => {
			let doc = data && data.length > 0 && data.map( ( value: any ) => {
				return {
					...value,
					documentType: "COMPANYBUYER",
					docs: undefined,
				};
			} );
			this.setState( { CompanyDocuments: doc }, () => {
				if ( this.state.documents.length < 1 ) {
					this.setDocuments();
				}
			} );
		} );
		populateENocMLookup( ENocMLookUp.EXPAT_DOCUMENTS, this, ( data ) => {
			let doc = data && data.length > 0 && data.map( ( value: any ) => {
				return {
					...value,
					documentType: "EXPAT",
					docs: undefined,
				};
			} );
			this.setState( { IndividualDocuments: doc }, () => {
				if ( this.state.documents.length < 1 ) {
					this.setDocuments();
				}
			} );
		} );
	}

	setDocuments() {
		this.setState( { documents: [] }, () => {
			const isCompany = this.props.ownershipType?.identity === OwnerType.COMPANY;
			let requiredDoc: ENocMLookupData[] = [];
			if ( isCompany ) {
				requiredDoc.push( ...this.state.CompanyDocuments );
			}
			if ( !this.props.isUAEResident ) {
				requiredDoc.push( ...this.state.IndividualDocuments );
			}
			this.setState( { documents: requiredDoc } );
		} );
	}

	componentDidUpdate( prevProps: Readonly<Prop>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevProps ) {
			if ( prevProps.isUAEResident !== this.props.isUAEResident || prevProps.ownershipType !== this.props.ownershipType ) {
				this.setDocuments();
			}
			if ( prevProps.documents !== this.props.documents ) {
				this.setState( { documents: this.props.documents } );
			}
		}
	}

	render() {
		const isView = this.props.mode === Mode.VIEW;
		return <React.Fragment>
			<div className="card">
				<div className="card-header">
					<span>{ Strings.documents }</span>
				</div>
				<div className="card-body">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					{ this.state.errorMsg && <div className="alert alert-info">{ this.state.errorMsg }</div> }
					{
						this.state.documents && this.state.documents.map( ( procDoc: EnocMollakDocuments, index: number ) => {
							let title = LocaleUtil.getLocalValue( procDoc );
							return <div key={ "docs_" + index }>
								{
									!( isView ) &&
									<Dropzone
										multiple={ false }
										maxSize={ 2 * 1024 * 1000 }
										onDropRejected={ this.onDropRejected }
										onDrop={ ( files: File[] ) => {
											this.onDrop( procDoc, files );
										} }
										accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
										{ ( { getRootProps, getInputProps } ) => (
											<DocumentInputField { ...getRootProps() }
											                    dropZoneInputProps={ getInputProps() }
											                    required={ procDoc.IsRequired }
											                    label={ title }
											                    error={ this.state.docsError ? this.state.docsError[ title ] : undefined }
											                    isDocsAdded={ procDoc.docs !== undefined }/>
										) }
									</Dropzone>
								}
								{
									isView && <label>{ title }</label>
								}
								{ procDoc.docs && <RendereNocDoc
									doc={ procDoc.docs } disable={ isView } onDelete={ ( identity: any ) => {
									this.onDelete( identity );
								} }/> }
							</div>;
						} )
					}
				</div>
			</div>
		</React.Fragment>;
	}

	onDropRejected() {
		showErrorMessage( Strings.tabu_file_exceed_size );
	}

	onDelete( identity: any ) {
		this.setState( {
			documents: this.state.documents.map( ( procDoc: EnocMollakDocuments ) => {
				if ( procDoc.identity === identity ) {
					procDoc.Path = undefined;
					procDoc.docs = undefined;
					procDoc.serverId = undefined;
					procDoc.url = undefined;
					return procDoc;
				}
				return procDoc;
			} ),
		} );
	}

	private onDrop = ( doc: EnocMollakDocuments, files: File[] ) => {
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( doc, file ) );
	};

	private addFile( upload: EnocMollakDocuments, file: File ) {
		const reader = new FileReader();
		let uploadDoc = _.cloneDeep( upload );
		reader.onload = () => {
			const binaryStr = reader.result;
			uploadDoc.docs = {
				identity: uploadDoc.identity,
				localData: binaryStr as string,
				fileName: file.name,
				fileSize: file.size,
				type: file.type,
				localFile: file,
			};
			uploadDoc.Path = undefined;
			uploadDoc.serverId = undefined;
			uploadDoc.url = undefined;
			uploadDoc.id = uploadDoc.identity;
			let error = this.state.error;
			if ( error[ uploadDoc.id! ] )
				delete error[ uploadDoc.id! ];
			this.setState( {
				docsError: error,
				documents: this.state.documents.map( ( doc: EnocMollakDocuments ) => {
					return ( uploadDoc.identity === doc.identity ) ? uploadDoc : doc;
				} ),
			} );
		};
		reader.readAsDataURL( file );
	}
}

function RendereNocDoc( props: { doc: eNocUploadDoc, onDelete: ( identity: any ) => void, disable: boolean } ) {
	const { doc, onDelete, disable } = props;
	let docType = getTabuDocType( doc );
	let preview = ( docType === TabuDocTypes.PDF ) ? <i className="far fa-file-pdf"/> : getImagePreview( doc );
	return <div className={ "mb-2" }>
		<table className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
			<thead>
			<tr>
				<th>{ Strings.file }</th>
				<th>{ Strings.name }</th>
				{
					!( disable ) &&
					<th>{ Strings.action }</th>
				}
			</tr>
			</thead>
			<tbody>
			<tr>
				<td>{ preview }</td>
				<td><a
					key={ `enoc_req_doc_${ doc.identity }` }
					onClick={ () => {
						window.open( doc.fileUrl );
					} }>
					<i/>{ getTabuDocName( doc ) }</a></td>
				{
					!( disable ) &&
					<td>
						<button
							className="btn btn-grey" onClick={ () => {
							onDelete( doc.identity );
						} }><i className="far fa-trash-alt"/>{ Strings.delete }
						</button>
					</td>
				}
			</tr>
			</tbody>
		</table>
	</div>;
}

function getImagePreview( tabuDoc: eNocUploadDoc ) {
	let source = ( tabuDoc.localData && !StringUtil.isEmptyStringOrNull( tabuDoc.localData ) ) ?
		tabuDoc.localData : tabuDoc.fileUrl;
	return <img src={ source } style={ { height: 40, width: 40 } } alt={ "uploaded_image" }/>;
}
